<div class="search-page">
  <div class="search-row">
    <div class="search-input">
      <p-iconfield iconPosition="left" class="ml-auto">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input pInputText #searchInput type="text" (input)="onSearch(searchInput.value)" placeholder="Search..."/>
      </p-iconfield>
    </div>

    @if (this.canCreate()) {
      <div class="search-row-buttons">
        <button pButton severity="secondary" (click)="openUploadForm()">
          <span pButtonLabel>{{ 'app.page.admin.data-lake-dashboard.action.add'|translate }}</span>
          <i class="pi pi-plus-circle" pButtonIcon></i>
        </button>
      </div>
    }
  </div>
  <p-table [value]="rows()">
    <ng-template #header>
      <tr>
        <th>{{ 'app.page.admin.data-lake-dashboard.table.header.file-name' | translate }}</th>
        <th>{{ 'app.page.admin.data-lake-dashboard.table.header.content-type' | translate }}</th>
        <th>{{ 'app.page.admin.data-lake-dashboard.table.header.size' | translate }}</th>
        <th>{{ 'app.page.admin.data-lake-dashboard.table.header.created-by' | translate }}</th>
        <th>{{ 'app.page.admin.data-lake-dashboard.table.header.created-date' | translate }}</th>
        <th>{{ 'app.page.admin.data-lake-dashboard.table.header.action' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template #body let-record>
      <tr>
        <td>{{ record.item.filename }}</td>
        <td>{{ record.item.contentType }}</td>
        <td>{{ record.item.sizeBytes | bytes }}</td>
        <td>{{ record.enrichments.creationAudit.creatorName }}</td>
        <td>{{ record.enrichments.creationAudit.createdAt | date:'yyyy/MM/dd hh:mm a' }}</td>
        <td>
          <button pButton (click)="download(record.item.id)">
            <i pButtonIcon class="pi pi-download"></i>
          </button>
          @if (this.localCanDelete()) {
            <button pButton (click)="delete(record.item.id)">
              <i pButtonIcon class="pi pi-times"></i>
            </button>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="paginator-row">
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="((+query().page! || 1) - 1) * (+query().pageSize! || 25)"
      [rows]="+query().pageSize! || 10"
      [totalRecords]="total()"
      [rowsPerPageOptions]="[10,15,25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      [showCurrentPageReport]="true"
    />
  </div>
</div>

<p-dialog
  [modal]="true"
  header="Upload to Data Locker"
  [showHeader]="true"
  [style]="{ width: 'fit-content' }"
  [visible]="uploadFormVisible()"
  (visibleChange)="uploadFormVisible.set($event)"
>
  @if (uploadFormVisible()) {
    <ems-file-upload (uploaded)="onSuccessfulUpload($event)"
                     [bucketConfig]="'datapool'"
                     [category]="'data'"
                     [validExtensions]="AI_TYPES"
    ></ems-file-upload>
  }
</p-dialog>
